import React from "react";
import {Templates, useTemplate} from "@/util-react/template.tsx";
import {B2bAdvertisingDefault} from "@/elements-react/b2b-advertising/templates/b2b-advertising.default.tsx";
import {
    B2bAdvertisingBlackAndBlue
} from "@/elements-react/b2b-advertising/templates/b2b-advertising.black-and-blue.tsx";

export interface B2BAdvertisingProps {
    className?: string;
    onButtonClick?: () => void;
}

const templates: Record<Templates, React.ComponentType<B2BAdvertisingProps>> = {
    [Templates.DEFAULT]: B2bAdvertisingDefault,
    [Templates.BLACK_AND_BLUE]:  B2bAdvertisingBlackAndBlue,
};

export const B2BAdvertising: React.FC<B2BAdvertisingProps> = (props: B2BAdvertisingProps) => {
    const template = useTemplate();
    const TemplatedComponent = templates[template.template ?? Templates.DEFAULT];

    return <TemplatedComponent {...props} />;

};

